import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/_core/_guards/auth.guard';
import { BuyGuard } from 'src/app/_core/_guards/buy.guard';
import { BuyVoucherComponent } from './buy-voucher/buy-voucher.component';
import { FavoritesComponent } from './favorites/favorites.component';
import { HomeComponent } from './home.component';
import { MainComponent } from './main/main.component';
import { SearchComponent } from './search/search.component';
import { VoucherComponent } from './voucher/voucher.component';
import { VouchersComponent } from './vouchers/vouchers.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        component: MainComponent
      },
      {
        path: 'vouchers',
        component: VouchersComponent
      },
      {
        path: 'voucher/:voucherId',
        component: VoucherComponent
      },
      {
        path: 'voucher/:voucherId/buy',
        component: BuyVoucherComponent,
        canActivate: [AuthGuard, BuyGuard]
      },
      {
        path: 'search',
        component: SearchComponent
      },
      {
        path: 'favourites',
        component: FavoritesComponent,
        canActivate: [AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
